module.exports = __webpack_public_path__ + "img/selected1-min.41d264a7.png";